
<template>
    <div>
        <mars-view><top-bar :no-blank="true" :home-flag="true" :title="topBar.title" :text-color="topBar.color" :bg-color="topBar.bgColor"></top-bar><mars-view class="container"><mars-view class="top"></mars-view><mars-view class="content"><mars-image class="success-icon" src="https://lvlin-base.cdn.bcebos.com/law/pages/directional/success-icon.png"></mars-image><mars-view class="success-title">您已支付成功</mars-view><mars-view class="line"></mars-view><mars-view class="success-text"><mars-view class="order">1</mars-view><mars-view>律师会在您支付后12小时内给您回电，请耐心等待。</mars-view></mars-view><mars-view class="success-text"><mars-view class="order">2</mars-view><mars-view>如律师未能在规定时间内答复，或遇到意外挂断及服务不满意，可搜索【百度律临】小程序，进入我的咨询订单<mars-text class="url" @click.native="jumpUrl('order')">申请退款</mars-text>。</mars-view></mars-view></mars-view></mars-view><mars-view class="btn"><mars-view class="go-home" @click.native="jumpUrl('home')">返回首页</mars-view><mars-view class="go-order" @click.native="jumpUrl('order')">查看订单</mars-view></mars-view></mars-view>
    </div>
</template>

<script>
import TopBar from "../../components/common/topbar.vue";
import { nav } from '../../static/utils/navigate.js';
/* globals getApp, Page, swan, getCurrentPages */

export default {
  components: {
    'top-bar': TopBar
  },
  data() {
    return {
      topBar: {
        title: '付费电话咨询',
        bgColor: 'custom',
        color: '#fff'
      }
    };
  },
  methods: {
    jumpUrl(type) {
      nav({
        url: type === 'order' ? '/pages/myconsult/index' : '/pages/home/index',
        type: type === 'order' ? 'nav' : 'switch'
      });
    }
  },
  created() {
    (function () {
      this.$root.$emit("marsPageAfterCreated", this);
    }).call(this, this.$route.query);
  },
  mounted() {
    this.$nextTick(() => {
      (function () {
        this.$root.$emit("marsPageAfterMounted", this);
      }).call(this, this.$route.query);
    });
  },
  destroyed() {
    (function () {
      this.$root.$emit("marsPageAfterDestroyed", this);
    }).call(this, this.$route.query);
  },
  activated() {
    (function () {
      this.$root.$emit("marsPageAfterActivated", this);
    }).call(this, this.$route.query);
  },
  deactivated() {
    (function () {
      this.$root.$emit("marsPageAfterDeactivated", this);
    }).call(this, this.$route.query);
  }
};
</script>

<style scoped>
.container {
  width: 100%;
  padding: 0 0.1rem;
  box-sizing: border-box;
  background-image: linear-gradient(1deg, rgba(62, 76, 255, 0) 0%, rgba(62, 76, 255, 0.9) 39%, #3e4cff 100%);
  background-size: 100% 2.2rem;
  background-repeat: no-repeat;
}
.container .top {
  width: 100%;
  height: 2.2rem;
  margin-bottom: -1.12rem;
}
.container .content {
  padding: 0.5rem 0.15rem 0.27rem;
  box-sizing: border-box;
  border-radius: 0.12rem;
  background-image: url('https://lvlin-base.cdn.bcebos.com/law/pages/directional/success-bg.png');
  background-repeat: no-repeat;
  background-color: #fff;
  background-size: 100% 1.8rem;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.container .content .success-icon {
  width: 0.7rem;
  height: 0.7rem;
}
.container .content .success-title {
  font-family: PingFangSC-Medium;
  font-size: 0.2rem;
  color: #1f1f1f;
  line-height: 1;
  font-weight: bold;
  margin-top: 0.2rem;
}
.container .content .line {
  width: 100%;
  height: 1px;
  background: #e6e6e6;
  margin-top: 0.2rem;
  opacity: 0.4;
}
.container .content .success-text {
  width: 100%;
  text-align: left;
  display: flex;
  justify-content: flex-start;
  font-size: 0.14rem;
  color: #1f1f1f;
  line-height: 0.22rem;
  margin-top: 0.2rem;
}
.container .content .success-text .order {
  min-width: 0.2rem;
  height: 0.2rem;
  background: rgba(64, 78, 255, 0.1);
  border-radius: 50%;
  font-family: PingFangSC-Semibold;
  font-size: 0.15rem;
  color: #3e4cff;
  line-height: 0.21rem;
  font-weight: bold;
  margin-right: 0.08rem;
  text-align: center;
}
.container .content .success-text .url {
  color: #404eff;
}
.btn {
  width: 100%;
  position: fixed;
  bottom: 0.7rem;
  left: 0;
  padding: 0 0.1rem;
  box-sizing: border-box;
}
.btn .go-home {
  width: 100%;
  height: 0.5rem;
  background: #404eff;
  border-radius: 75px;
  font-family: PingFangSC-Medium;
  font-size: 0.18rem;
  color: #fff;
  line-height: 0.52rem;
  font-weight: bold;
  margin-bottom: 0.2rem;
  text-align: center;
}
.btn .go-order {
  width: 100%;
  height: 0.5rem;
  background: transparent;
  font-family: PingFangSC-Medium;
  font-size: 0.18rem;
  color: #1f1f1f;
  line-height: 0.52rem;
  font-weight: bold;
  border: 1px solid rgba(151, 151, 151, 0.4);
  border-radius: 75px;
  box-sizing: border-box;
  text-align: center;
}

</style>
